import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId, getDeleted } from "@/store/Crud/functions/getters";

export const getTestItem = (state: State) => state.testItem;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getTestItem,
  getId,
  getDeleted,
};
